const rules = {
  required: () => {return {type: 'required'}},
  atLeast: (atLeast) => {return {type: 'atLeast', atLeast: typeof(atLeast) === 'number' ? atLeast : 10}},
  email: (validateFunc) => {return {type: 'email', validator: typeof(validateFunc) === 'function' ? validateFunc : undefined}},
}

export default rules;